export default __webpack_public_path__ + "static/media/social-media.cce02c87.svg";